import React from "react";

// components

import CardTable from "components/Tables/CardTable.js";

export default function Orders() {
    return (
        <>
            <div className="flex flex-wrap mt-4">
                <div className="w-full mb-12 px-4">
                    <CardTable
                        color="light"
                        heading="Orders"
                        route="/admin/orders/create"
                        columns={[
                            { label: "Customer", key: "customer", render: (value) => <b>{value}</b> },
                            { label: "Product", key: "product" },
                            { label: "Quantity", key: "quantity", render: (value) => <span>{value}</span> },
                            { label: "Price", key: "price", render: (value) => <span>{`$${value.toFixed(2)}`}</span> },
                            { label: "Status", key: "status", render: (value) => <span>{value}</span> },
                        ]}
                        data={[
                            {
                                customer: "John Doe",
                                product: "Organic Avocados",
                                quantity: 10,
                                price: 25.00,
                                status: "Pending",
                            },
                            {
                                customer: "Jane Smith",
                                product: "Almond Milk",
                                quantity: 5,
                                price: 12.50,
                                status: "Shipped",
                            },
                            {
                                customer: "Mohamed Ali",
                                product: "Whole Wheat Bread",
                                quantity: 2,
                                price: 6.00,
                                status: "Delivered",
                            },
                            {
                                customer: "Emma Williams",
                                product: "Granola Bars",
                                quantity: 3,
                                price: 9.00,
                                status: "Cancelled",
                            },
                            {
                                customer: "Liam Johnson",
                                product: "Chickpeas (Canned)",
                                quantity: 8,
                                price: 16.00,
                                status: "Pending",
                            },
                            {
                                customer: "Olivia Brown",
                                product: "Organic Tomatoes",
                                quantity: 6,
                                price: 18.00,
                                status: "Shipped",
                            },
                        ]}
                    />

                </div>
            </div>
        </>
    );
}